import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { DataStudioRedesignComponent } from './data-studio-redesign.component';


const routes: Routes = [
  {
    path: 'data_studio',
    component: DataStudioRedesignComponent
  },
  {
    path: '',
    redirectTo: 'data_studio',
    pathMatch: 'full'
  },
  {
    path: '**',
    redirectTo: 'data_studio'
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class DataStudioRedesignRoutingModule { }
